import { TagGroup } from '../../entity'
import { Expose } from 'class-transformer'

export class ListTagsDTO {

    @Expose()
    tagGroups!: TagGroup[]

}